module.exports = __webpack_public_path__ + "static/img/m1932.8548114.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/m1932.png
// module id = 9QTW
// module chunks = 1